
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { SystemRoleSettingsDto_$reflection } from "../../Shared/Roles.js";
import { ClientApiResponse$1_$reflection, RequestedValue$1_$reflection, FormState_$reflection } from "../../Shared/Shared.js";
import { union_type, class_type, record_type, unit_type, lambda_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class SystemRoleSettingsProps extends Record {
    constructor(Settings, FormState, OnUpdate) {
        super();
        this.Settings = Settings;
        this.FormState = FormState;
        this.OnUpdate = OnUpdate;
    }
}

export function SystemRoleSettingsProps_$reflection() {
    return record_type("Settings.SystemRoleSettings.Types.SystemRoleSettingsProps", [], SystemRoleSettingsProps, () => [["Settings", SystemRoleSettingsDto_$reflection()], ["FormState", FormState_$reflection()], ["OnUpdate", lambda_type(lambda_type(SystemRoleSettingsDto_$reflection(), SystemRoleSettingsDto_$reflection()), unit_type)]]);
}

export class State extends Record {
    constructor(Settings, FormState) {
        super();
        this.Settings = Settings;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.SystemRoleSettings.Types.State", [], State, () => [["Settings", RequestedValue$1_$reflection(SystemRoleSettingsDto_$reflection())], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateSettings", "SettingsFetched", "SettingsUpdated", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.SystemRoleSettings.Types.Msg", [], Msg, () => [[["Item", lambda_type(SystemRoleSettingsDto_$reflection(), SystemRoleSettingsDto_$reflection())]], [["Item", SystemRoleSettingsDto_$reflection()]], [["Item", ClientApiResponse$1_$reflection(SystemRoleSettingsDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

